import * as PropTypes from 'prop-types';
import * as React from 'react';
import { SanitizedRender, UserStore } from '@reverbdotcom/discovery-ui';
import * as BumpDiagram from '../../../../../images/products/bump-marketing-icon.svg';
import * as BumpIcon from '../../../../../images/icons/bump-icon-2.svg';
import HideableSlider from './hideable_slider';
import BumpBarGraphic from './bump_bar_graphic';
import UrlHelpers from '../../../shared/url_helpers';

function bumpChargeExplanation(exampleBumpPercent, listingPrice, shippingPrice, exampleSpend) {
  if (shippingPrice) {
    return (
      <SanitizedRender
        html={
            I18n.t('js.bump.setup.bumpChargesExplainedWithShipping', {
            exampleBumpPercent,
            listingPrice,
            shippingPrice,
            exampleSpend,
          })
        }
      />
    );
  }

  return (
    <SanitizedRender
      html={
          I18n.t('js.bump.setup.bumpChargesExplainedNoShipping', {
          exampleBumpPercent,
          listingPrice,
          exampleSpend,
        })
      }
    />
  );
}

function BumpSellMarketingContent1() {
  return (
    <div className="product-bump__overview-col">
      <div className="product-bump__overview-col__grid-wrap">
        <div className="product-bump__overview-col__grid-wrap__icon">
          <a href="/page/bump">
            <img src={BumpDiagram} alt={I18n.t('js.bump.setup.explanation.bumpIcon')} className="d-block width-100" />
          </a>
        </div>
        <div className="product-bump__overview-col__marketing-wrap">
          <h3 className="product-bump__overview-col__heading">
            {I18n.t('js.bump.setup.bumpHelpsSell')}
          </h3>
          <p className="product-bump__overview-col__subheading">
            <SanitizedRender
              html={
                  I18n.t('js.bump.setup.bumpHelpsSellSubheading', {
                  linkOpen: '<a href="/page/bump" target="_blank">',
                  linkClose: '</a>',
                })
              }
            />
          </p>
          <ol className="product-bump__overview-col__benefits-list">
            <li className="product-bump__overview-col__benefits-list__item">
              <span>{I18n.t('js.bump.setup.explanation.one')}</span>
              {I18n.t('js.bump.setup.explanation.stepOne')}
            </li>
            <li className="product-bump__overview-col__benefits-list__item">
              <span>{I18n.t('js.bump.setup.explanation.two')}</span>
              {I18n.t('js.bump.setup.explanation.stepTwo')}
            </li>
            <li className="product-bump__overview-col__benefits-list__item">
              <span>{I18n.t('js.bump.setup.explanation.three')}</span>
              {I18n.t('js.bump.setup.explanation.stepThree')}
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
}

function BumpSellMarketingContent2() {
  return (
    <div className="product-bump__overview-col">
      <h2 className="product-bump__overview-title">
        <img src={BumpIcon} alt={I18n.t('js.bump.setup.explanation.bumpIcon')} />
        <p>
          {I18n.t('js.bump.reverbBump')}
        </p>
      </h2>
      <p className="product-bump__overview-subtitle">
        {I18n.t('js.bump.setup.listingOnBiggerStage')}
      </p>
      <p className="product-bump__overview-description">
        {I18n.t('js.bump.setup.premiumPlacement')}
        <br />
        <a href={UrlHelpers.cmsPagePath('bump')} target="_blank">
          {I18n.t('js.bump.setup.learnMore')}
        </a>
      </p>
    </div>
  );
}

function renderBumpSellMarketingContent() {
  if (UserStore.isExperimentEnabled('bump_alt_marketing_content')) {
    return <BumpSellMarketingContent2 />;
  }

  return <BumpSellMarketingContent1 />;
}

const BumpSetup = ({
  bidSlider,
  exampleBumpPercent,
  listingPrice,
  shippingPrice,
  exampleSpend,
  isNewCondition,
  showMobileSlider,
  sliderToggle,
}) => (
  <div className="product-bump__wrapper">
    {renderBumpSellMarketingContent()}
    <div className="product-bump__slider-col">
      <HideableSlider
        label={I18n.t('js.bump.setup.selectBumpTier')}
        sliderToggle={sliderToggle}
        showMobileSlider={showMobileSlider}
      >
        <h4 className="product-bump__slider-col__label">
          {I18n.t('js.bump.setup.pickBumpTier')}
        </h4>
        <div className="product-bump__views-scale">
          <div className="produt-bump__scale-img">
            <div className="produt-bump__scale-img__inner">
              <BumpBarGraphic
                highlightStartPercentage={50}
                highlightEndPercentage={80}
              />
            </div>
          </div>
          <div className="product-bump__views-scale__more">{I18n.t('js.bump.setup.moreViews')}</div>
          <div className={
              `product-bump__views-scale__most-popular
                ${isNewCondition ?
                  ' product-bump__views-scale__most-popular--new' :
                  ' product-bump__views-scale__most-popular--used'
                }
              `
            }
          >
            {I18n.t('js.bump.setup.recommendedTiers')}
          </div>
          <div className="product-bump__views-scale__much-more">{I18n.t('js.bump.setup.manyMoreViews')}</div>
        </div>
        {bidSlider}
        <h4 className="bump-charges__heading">{I18n.t('js.bump.setup.example')}</h4>
        <p className="bump-charges__description">
          {bumpChargeExplanation(exampleBumpPercent, listingPrice, shippingPrice, exampleSpend)}
        </p>
      </HideableSlider>
    </div>
  </div>
);

BumpSetup.propTypes = {
  bidSlider: PropTypes.element.isRequired,
  exampleBumpPercent: PropTypes.string.isRequired,
  listingPrice: PropTypes.string.isRequired,
  shippingPrice: PropTypes.string.isRequired,
  exampleSpend: PropTypes.string.isRequired,
  isNewCondition: PropTypes.bool,
  showMobileSlider: PropTypes.bool,
  sliderToggle: PropTypes.func,
};

export default BumpSetup;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/bump_for_new/bump_setup.jsx